'use client'

import { JoinClubhouseModalWrapper } from './join-clubhouse-modal-wrapper'
import * as React from 'react'

export interface JoinClubhouseModalContextModel {
  isOpen: boolean
  openModal: (slug: string) => void
  closeModal: () => void
  slug: string | null
}

const JoinClubhouseModalContext = React.createContext<JoinClubhouseModalContextModel>(null!)

export const JoinClubhouseModalProvider = ({ children }: React.PropsWithChildren) => {
  const [isOpen, setIsOpen] = React.useState<boolean>(false)
  const [slug, setSlug] = React.useState<string | null>(null)

  const openModal = (slug: string) => {
    setSlug(slug)
    setIsOpen(true)
  }

  const closeModal = () => {
    setIsOpen(false)
    setSlug(null)
  }

  return (
    <JoinClubhouseModalContext.Provider value={{ isOpen, closeModal, openModal, slug }}>
      {children}
      <JoinClubhouseModalWrapper />
    </JoinClubhouseModalContext.Provider>
  )
}

export const useJoinClubhouseModal = () => {
  const context = React.useContext(JoinClubhouseModalContext)

  if (context === undefined) {
    throw new Error('useJoinClubhouseModal must be used within a JoinClubhouseModalProvider')
  }

  return context
}
